// extracted by mini-css-extract-plugin
export default {"changePasswordSection":"style_changePasswordSection__xMP66","actionsSection":"style_actionsSection__DVJAt","formSection":"style_formSection__iIbT0"};